import { render, staticRenderFns } from "./CookieConsent.vue?vue&type=template&id=52cd8308&"
import script from "./CookieConsent.vue?vue&type=script&lang=js&"
export * from "./CookieConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports